import React, {Component} from 'react';
import ReportTemplatesContainer from '../../../containers/report_template_container';
import {Button, Grid, Header, Segment} from "semantic-ui-react";

class ReportTemplateList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            action: 'listing',
            selectedTemplate: undefined,
            editTemplate:false
        }
    }

    componentWillMount() {
        this.props.getTemplateList();
    }

    render() {
        const templates = this.props.templates;
        return (<div style={{width: "90%", margin: 'auto', paddingTop: '2%'}}>
            <Header size="large" textAlign="left">
                <span>Report Templates  </span><span><Button as="a" href={"/report/template/create"} target="_blank" primary >Add New Template</Button></span>
            </Header>
            <Grid style={{maxHeight: window.screen.height * 0.60}}>
                <Grid.Column width={5} style={{maxHeight: '90%', overflowY: 'scroll'}}>
                    {templates && templates.length > 0 ? <Segment.Group>
                        {templates.map((template, i) => {
                                return (<Segment key={i}>
                                    <div style={{display: 'table'}}>
                                        <span style={{
                                            display: 'table-cell',
                                            width: '80%',
                                            verticalAlign: 'middle'
                                        }}>{template['report_template'].name}</span>
                                        <span style={{display: 'table-cell'}}>
                                            <Button primary content={"View"}
                                                    className="pull-right"
                                                    onClick={() => {
                                                        this.setState({selectedTemplate: template['report_template']})
                                                    }}/>
                                        </span>
                                    </div>
                                </Segment>)
                            }
                        )}
                    </Segment.Group> : <Segment><span>No Templates Found</span></Segment>}
                </Grid.Column>
                {!this.state.editTemplate && <Grid.Column width={11}>
                    {this.state.selectedTemplate ?
                        <div>
                            <Header content={this.state.selectedTemplate.name}/>
                            <div style={{width:'80%',margin:'auto'}}>
                                <ol>
                                {this.state.selectedTemplate['selected_modules'].length > 0 ? this.state.selectedTemplate['selected_modules'].map((module,i) => {
                                return (
                                    <li key={module.id}>
                                       <Header as='h4' content={module.name}/>
                                    </li>
                                )
                            }):<div>No modules linked to this template.</div>}
                                </ol>
                            </div>
                        </div> :
                        <p className="center-aligned"> No Template selected to View</p>}
                    {this.state.selectedTemplate && <div className="right-aligned">
                            <Button primary content="Edit Template" onClick={()=>{this.props.history.push('/report/template/update/'+this.state.selectedTemplate.id)}}/>
                        </div>}
                </Grid.Column>}
            </Grid>
        </div>)
    }
}

export default ReportTemplatesContainer(ReportTemplateList)



// WEBPACK FOOTER //
// ./src/views/report/templates/index.js